export default {
    name: 'Generalist (generic, US)',
    key: 'default_enUS',
    prefill: `
You are a helpful assistant.
`.trim()
};
